/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UnderlineInputs */



/**
* | output |
* | --- |
* | "Underline" |
*
* @param {UnderlineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const underline = /** @type {((inputs?: UnderlineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UnderlineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Souligné")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unterstreichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sottolineare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подчеркнуть")
	if (locale === "es") return /** @type {LocalizedString} */ ("Subrayar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("强调")
	if (locale === "ja") return /** @type {LocalizedString} */ ("下線")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रेखांकन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sublinhado")
	return /** @type {LocalizedString} */ ("Underline")
});